var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackwardEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#717579",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4142 37.89L30.6142 31.09L37.4142 24.29L39 25.8772L33.7871 31.0901L39 36.303L37.4142 37.89Z",
    fill: "#717579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3087 37.89L22.5087 31.09L29.3087 24.29L30.8945 25.8772L25.6816 31.0901L30.8945 36.303L29.3087 37.89Z",
    fill: "#717579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardEnabled);
export default __webpack_public_path__ + "static/media/backwardEnabled.c1213501e32105e3573e041917ff9cfe.svg";
export { ForwardRef as ReactComponent };